module.exports = __webpack_public_path__ + "img/numberplateEuropeGeneric.edb3fefa.svg";